import React from 'react';
import { RelayEnvironmentProvider as DefaultProvider } from 'react-relay';
import { Environment } from 'relay-runtime';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
var environment = new Environment(getDefaultRelayEnvironmentConfig({}));
export var RelayEnvironmentProvider = function RelayEnvironmentProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DefaultProvider, {
    environment: environment
  }, children);
};